import { BlockStack, Text, ProgressBar } from '@shopify/polaris';
import { useLanguage } from '../providers/LanguageProvider';

interface UsageProgressBarProps {
  includedTryOns: number;
  usedTryOns: number;
  remainingTryOns: number;
}

export default function UsageProgressBar({
  includedTryOns,
  usedTryOns,
  remainingTryOns,
}: UsageProgressBarProps) {
  const { t } = useLanguage();

  // A free/no-subscription state may have no included try-ons. Never pass NaN
  // or Infinity into Polaris's progress element.
  const usedPercent = includedTryOns > 0 ? (usedTryOns / includedTryOns) * 100 : 0;
  const cappedPercent = Math.max(0, Math.min(usedPercent, 100));

  const getTone = (): 'success' | 'critical' => {
    if (usedPercent > 80) return 'critical';
    return 'success';
  };

  return (
    <BlockStack gap="400">
      <BlockStack gap="200">
        <Text as="p" variant="bodyMd" fontWeight="semibold">
          {t.usageProgress.title}
        </Text>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Text as="span" variant="bodySm">
            {t.usageProgress.used(usedTryOns)}
          </Text>
          <Text as="span" variant="bodySm">
            {t.usageProgress.included(includedTryOns)}
          </Text>
        </div>
      </BlockStack>

      <ProgressBar progress={cappedPercent} tone={getTone()} />

      <Text as="span" variant="bodySm" tone="subdued">
        {t.usageProgress.remaining(remainingTryOns)}
      </Text>
    </BlockStack>
  );
}
